function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "New Patient");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "New-Patient",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M504,572 C596.75,572 672,647.25 672,740 L672,740 L672,772 C672,805.125 645.125,832 612,832 L612,832 L172,832 C138.875,832 112,805.125 112,772 L112,772 L112,740 C112,647.25 187.25,572 280,572 C316,572 333.125,592 392,592 C450.875,592 468.125,572 504,572 Z M504,632 C485.625,632 456.625,652 392,652 C327.875,652 298.25,632 280,632 C220.5,632 172,680.5 172,740 L172,740 L172,772 L612,772 L612,740 C612,680.5 563.5,632 504,632 Z M392,192 C491.375,192 572,272.625 572,372 C572,471.375 491.375,552 392,552 C292.625,552 212,471.375 212,372 C212,272.625 292.625,192 392,192 Z M392,252 C325.875,252 272,305.875 272,372 C272,438.125 325.875,492 392,492 C458.125,492 512,438.125 512,372 C512,305.875 458.125,252 392,252 Z M781,192 C792,192 801,201 801,212 L801,212 L801,302 L891,302 C902,302 911,311 911,322 L911,322 L911,342 C911,353 902,362 891,362 L891,362 L801,362 L801,452 C801,463 792,472 781,472 L781,472 L761,472 C750,472 741,463 741,452 L741,452 L741,362 L651,362 C640,362 631,353 631,342 L631,342 L631,322 C631,311 640,302 651,302 L651,302 L741,302 L741,212 C741,201 750,192 761,192 L761,192 Z",
  id: "Combined-Shape",
  fill: "currentColor",
  fillRule: "nonzero"
}));

var SvgAddUser = function SvgAddUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1024px",
    height: "1024px",
    viewBox: "0 0 1024 1024",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-user.859c7980.svg";
export { ForwardRef as ReactComponent };